import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Text } from "sunrise-ui";
import { CHART_COLORS, customTooltip } from "../../../constants/reactChartConstants";

//-------bar chart data------------
const pilesCompletedChartData = {
    labels: [],
    datasets: [
        {
            label: "Nos",
            data: [],
            backgroundColor: [CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE],
            barThickness: 20
        }
    ],

};

const metersCompletedChartData = {
    labels: [],
    datasets: [
        {
            label: "Meters",
            data: [],
            backgroundColor: [CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE],
            barThickness: 20
        }
    ],

};

const avgPileCycleChartData = {
    labels: [],
    datasets: [
        {
            label: "Hrs",
            data: [],
            backgroundColor: [CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE],
            barThickness: 20
        }
    ],

};

const rigWiseCompletedPileBarOptions = {
    plugins: {
        tooltip: customTooltip,
        legend: {
            display: false
        }
    },
    maintainAspectRatio: true,
    scales: {
        y: {
            title: {
                display: true, text: 'Completed Piles (Nos)', font: { weight: 'bold' }
            },
            ticks: {
                precision: 0
            }
        },
        x: { title: { display: true, text: 'RIGS', font: { weight: 'bold' } } },
    }
}

const rigWisePileBarOptions = {
    plugins: {
        tooltip: customTooltip,
        legend: {
            display: false
        }
    },
    maintainAspectRatio: true,
    scales: {
        y: { title: { display: true, text: 'Pile Length Completed (Meters)', font: { weight: 'bold' } } },
        x: { title: { display: true, text: 'RIGS', font: { weight: 'bold' } } },
    }
}

const rigWisePileCycleBarOptions: any = {
    plugins: {
        tooltip: customTooltip,
        legend: {
            display: false
        }
    },
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
        y: { title: { display: true, text: 'RIGS', font: { weight: 'bold' } } },
        x: {
            title: { display: true, text: 'Pile Cycle (Hrs)', font: { weight: 'bold' } }, ticks: {
                precision: 2
            }
        },
    }
}

const MultipleRigReport = ({ machineData, machineNames }: any) => {

    const [multiDurationData, setMultiDurationData] = useState([]);
    const [multiCompletedPiles, setMultiCompletedPiles] = useState([]);
    const [multiCompletedMeters, setMultiCompletedMeters] = useState([]);

    useEffect(() => {
        const avgData = machineData?.map((rig: any) => (Math.round(rig.averageDuration * 100 / (60 * 60)) / 100));
        const compltedPiles = machineData?.map((rig: any) => (rig.completedPileCount));
        const compltedMeters = machineData?.map((rig: any) => (rig.completedMeters));
        setMultiDurationData(avgData);
        setMultiCompletedPiles(compltedPiles);
        setMultiCompletedMeters(compltedMeters);
    }, [machineData])

    return (
        <>
            <Grid container xs={12} spacing={4}>
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Rig-Wise Pile Completed (Nos)</span>
                        </Text>
                    </Grid>
                    <Bar data={{ ...pilesCompletedChartData, labels: machineNames, datasets: [{ ...pilesCompletedChartData.datasets[0], data: multiCompletedPiles }] }} options={rigWiseCompletedPileBarOptions} />
                </Grid>
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Rig-Wise Completed Piles (meters)</span>
                        </Text>
                    </Grid>
                    <Bar data={{ ...metersCompletedChartData, labels: machineNames, datasets: [{ ...metersCompletedChartData.datasets[0], data: multiCompletedMeters }] }} options={rigWisePileBarOptions} />
                </Grid>
            </Grid>

            <Grid item xs={6}>
                <Grid item xs={12}>
                    <Text
                        type="normal"
                        fonts="normal"
                        fontSize={18}
                        className="mb0 mt1"
                    >
                        <span className="fw500">Rig-Wise Average Pile Cycle (hrs)</span>
                    </Text>
                </Grid>
                <div style={{ height: '25rem', width: '95%' }}>
                    <Bar data={{ ...avgPileCycleChartData, labels: machineNames, datasets: [{ ...avgPileCycleChartData.datasets[0], data: multiDurationData }] }} options={rigWisePileCycleBarOptions} />
                </div>

            </Grid>
        </>
    );
}

export default MultipleRigReport;